module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"suggested":"Suggested Translation","cancel":"Cancel","overwrite":"Overwrite","translate":"Translate"},"de":{"suggested":"Vorgeschlagene Übersetzung","cancel":"Abbrechen","overwrite":"Überschreiben","translate":"Übersetzen","btnTranslate":"Übersetzen"}}')
  delete Component.options._Ctor
}
